import styled from "styled-components";

export const Container = styled.div``;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ImageWrap = styled.div`
  position: relative;
  width: 156px;
  height: 110px;

  @media only screen and (max-width: 560px) {
    width: 78px;
    height: 56px;
  }
`;

export const TitleText = styled.div`
  ${({ theme }) => theme.textStyles.sectionTitle};
  padding: ${({ theme }) => theme.spacings.spacing_sm} 0;
  display: flex;
  justify-content: center;
  text-align: center;

  @media only screen and (max-width: 560px) {
    font-size: 22px;
  }
`;

export const ContentWrap = styled.div`
  display: flex;
  justify-content: center;
`;

export const SummaryContent = styled.div`
  ${({ theme }) => theme.textStyles.content2};
  padding-bottom: ${({ theme }) => theme.spacings.spacing_xss};
  max-width: 670px;
  text-align: center;

  @media only screen and (max-width: 560px) {
    font-size: 16px;
    max-width: 330px;
  }
`;

export const Highlight = styled.span`
  font-family: "OpenSans SemiBold";
  font-size: 20px;
  color: ${({ theme }) => theme.colors.prune};

  @media only screen and (max-width: 560px) {
    font-size: 16px;
  }
`;
